import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import AlertSetupWizard from '../components/AlertSetupWizard';

const CreateAlert: React.FC = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate('/dashboard');
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-indigo-50">
      <Navigation />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Create New Alert
          </h1>
          <p className="text-lg text-gray-600">
            Set up monitoring for your AI API usage
          </p>
        </div>
        <AlertSetupWizard onComplete={handleComplete} onCancel={handleCancel} />
      </main>
      <Footer />
    </div>
  );
};

export default CreateAlert;
